import React from 'react';
import Logo from '../../components/common/Logo';
import DoctorSidebar from '../../components/dashboard-doctor/DoctorSidebar';
import DoctorCalendar from '../../components/admin/AdminDoctorCalendar';

const DoctorCalendarPage = () => {
  // Ottieni l'ID del dottore dal localStorage invece che da un hook di autenticazione
  const user = JSON.parse(localStorage.getItem('user')) || {};
  
  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <DoctorSidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 bg-[#FAF4EB] p-8">
        <header className="mb-8">
          <h1 className="text-2xl font-bold">Calendario</h1>
          <p className="text-gray-600">Gestisci i tuoi orari e visualizza gli appuntamenti</p>
        </header>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <DoctorCalendar therapistId={user.id} />
        </div>
      </div>
    </div>
  );
};

export default DoctorCalendarPage;